module.exports = __webpack_public_path__ + "static/about-us-image3-2195b139b3f00c769709c726a099d4a4.jpg";